import { API } from "./API";

const DEFAULT_OPTIONS = {
  baseUrl: "auth",
};

export class AuthenticationAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  login() {
    const params = ["login"];
    return super.post({ params });
  }

  logout() {
    const params = ["logout"];
    return super.post({ params });
  }
}
